<template>
    <div class="container-fluid">

      <div class="container-fluid" >
          <div class="d-flex justify-content-center">      
            <q-linear-progress v-if="!chartLoaded" color="primary" indeterminate />

        </div>
  
        <div class="graph-container">
            <div class="graph-chart large-graph" v-if="chartLoaded && entryChartData">
                <Line :chartData="this.entryChartData" :chartOptions="this.entryChartOptions"/>
            </div>

            <!-- <div v-if="chartLoaded" class="graph-chart medium-graph">
                <Pie v-bind:chartData="this.individualWaitlistChartData"
                v-bind:chartOptions="individualWaitlistChartOptions"/>
            </div> -->
  
            <div v-if="chartLoaded && waitlistChartData" class="graph-chart medium-graph">
                <Pie v-bind:chartData="this.waitlistChartData"
                v-bind:chartOptions="waitlistChartOptions"/>
                <q-btn class="graph-drill-in-btn" color="secondary" no-caps @click="this.retrieveWaitlistData" label="View Current Waitlist"/>
            </div>

        </div>
      </div>
      <q-inner-loading
          :showing="visible"
          label="Please wait..."
          label-class="text-teal"
          label-style="font-size: 1.1em"
        />
    </div>
  
  </template>
  
  <script>
  
  
  import api from "../../services/api/api"
  import notify from '@/services/util/notify';
  
  import Pie from "../ChartComponents/Pie.vue"
  import Line from "../ChartComponents/Line.vue"
  import { retPieOptions, retLineOptions } from "../DataComponents/chartOptions";
  
  import ClientWaitlistTableComponent from "./ClientWaitlistTableComponent.vue";
  
  export default ({
    name: 'ClientDemographics',
    components: { Pie, Line },
    props: ['query'],
  
    data() {
      return {

        chartLoaded: false,
  
        entryChartData: null,
        waitlistChartData: null,
        individualWaitlistChartData: null,
  
        entryChartOptions: retLineOptions("Entry and Exit Data", "x", "# of People", "Date"),
        waitlistChartOptions: retPieOptions("Time Spent on Waitlist Before Being Activated", "Category"),
        individualWaitlistChartOptions: retPieOptions("Time Spent on Waitlist - 1 on 1 (Active)", "Category"),
  
        visible: false,
  
        waitlistData: null,
        waitlistColumns: [
          { name: 'name', align: 'left', label: 'Name', field: row => `${row.first_name} ${row.last_name}`, sortable: true },  
          { name: 'programme', align: 'left', label: 'Programme', field: 'programme_id', sortable: true },
          { name: 'user', align: 'left', label: 'Assigned Staff', field: 'user_id', sortable: true },
          { name: "entry_date", align: "left", label: "Entry Date", field: row => row.entry_date.split('T')[0], sortable: true },
          { name: 'days_elapsed', align: 'left', label: 'Time from Triage to Now', field: 'days_elapsed', sortable: true },
          { name: "updated_at", align: "left", label: "Last Updated", field: row => row.updated_at.split('T')[0], sortable: true },
        ],
      }
    },

    created() {
      this.onIntialize();
    },
  
    methods: {
  
      /**
       * Set all the required chart data and chart options.
       */
      onIntialize() {
  
        // Fetch all client data from backend. Returns list of data once all requests have completed
        const fetchData = (query) => Promise.all([
            api.clientGraph.clientEntry(query).catch(error => ({ error })),
            api.clientGraph.clientWaitlist(query).catch(error => ({ error })),
            // api.clientGraph.clientIndividualWaitlist(query).catch(error => ({ error })),
          ])
  
        fetchData(this.query).then((values) => {

          const chartData = values.map(value => value.error ? null : value.data);

          this.entryChartData = chartData[0];
          this.waitlistChartData = chartData[1];
          // this.individualWaitlistChartData = chartData[2];

          this.$emit("displayErrors", values);
  
          this.chartLoaded = true
        }).catch(() => {
            notify.error("Error retrieving client flow data", 'top');
          }).finally(() => {
        this.chartLoaded = true;
      });
    },


      /**
       * Retrieve the additional raw data for the drill in
       */
      retrieveWaitlistData() {
  
        this.visible = !this.visible
  
        api.client.getWaitlistData(this.query).then((res) => {
          this.waitlistData = res.data
          this.visible = !this.visible
  
          this.$q.dialog({
            component: ClientWaitlistTableComponent,
            parent: this,
            componentProps: {
              tableTitle: "Current Waitlist",
              rows: this.waitlistData,
              columns: this.waitlistColumns
            }
          })
        }).catch(() => {
          this.visible = !this.visible
          notify.error("Error opening table", 'top');
        })
      },
    },
  })
  
  
  
  </script>
  
  <style scoped>
  @import '../../assets/styles/clientDemographics.css';
  </style>
